import { loginUser, resetPassword, updatePassword } from '@/System/Store/Api/ApiUser';
import { setSnackbar } from '@/helpers';

const initialState = () => ({
    passwordResetRequested: false,
});

const state = initialState();

const mutations = {
    SET_PASSWORD_RESET_REQUESTED: (state, payload) => (state.passwordResetRequested = payload),
    RESET_STATE: (state) => Object.assign(state, initialState()),
};

const actions = {
    LOGIN_PASSWORD({ commit, dispatch }, payload) {
        loginUser(payload).then((response) => {
            if (response.status === 'Success') {
                commit('UserStore/SET_TOKEN', response.data.token, { root: true });
                dispatch('Departments/SET_DEPARTMENTS', response.data.departments, { root: true });
                dispatch('UserStore/GET_ME', null, { root: true });
            } else {
                const snackbar = setSnackbar(response);
                commit('GlobalStore/SET_SNACKBAR', snackbar, { root: true });
            }
        });
    },
    RESET_PASSWORD({ commit }, payload) {
        resetPassword(payload).then((response) => {
            if (response.status === 'Success') {
                commit('SET_PASSWORD_RESET_REQUESTED', true);
            } else {
                const snackbar = setSnackbar(response);
                commit('GlobalStore/SET_SNACKBAR', snackbar, { root: true });
            }
        });
    },
    async UPDATE_PASSWORD({ commit, dispatch }, payload) {
        return await updatePassword(payload).then((response) => {
            const snackbar = setSnackbar(response);
            commit('GlobalStore/SET_SNACKBAR', snackbar, { root: true });

            if (response.status === 'Success' && response?.data?.token) {
                commit('SET_PASSWORD_RESET_REQUESTED', false);
                commit('UserStore/SET_TOKEN', response.data.token, { root: true });

                dispatch('Departments/SET_DEPARTMENTS', response.data.departments, { root: true });
                dispatch('UserStore/GET_ME', null, { root: true });
            }

            return response.status === 'Success';
        });
    },
};

const getters = {
    IS_PASSWORD_RESET_REQUESTED: (state) => state.passwordResetRequested,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
